"use client";

import React from "react";
import { Calendar, Activity, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const timelineSteps = [{
  period: "1-3 meses",
  description: "Reducción de la caída",
  icon: Calendar
}, {
  period: "3-6 meses",
  description: "Mejora de calidad y grosor",
  icon: Activity
}, {
  period: "6-12 meses",
  description: "Aumento progresivo de densidad",
  icon: Sparkles
}];
export default function HairImprovementTimeline() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hairimprovementtimeline" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="bg-secondary text-secondary-foreground py-16 px-6 md:px-12 relative overflow-hidden shadow-xl">
          {}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-primary/40"></div>
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-16 bg-primary/40"></div>

          <div className="max-w-4xl mx-auto relative z-10">
            <div className="text-center mb-16 md:mb-24">
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-secondary-foreground mb-4">
                ¿Cuándo empezaré a notar mejoría?
              </h2>
              <div className="w-24 h-1 bg-primary mx-auto mt-6"></div>
            </div>

            <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              {}
              <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-primary/30 md:-translate-x-1/2"></div>

              <div className="space-y-12 md:space-y-0">
                {timelineSteps.map((step, i) => {
                const Icon = step.icon;
                const isEven = i % 2 === 0;
                return <div key={i} data-index={i} className="relative flex flex-col md:flex-row items-start md:items-center md:h-48">
                      {}
                      <div className="absolute left-6 md:left-1/2 -translate-x-1/2 w-12 h-12 bg-secondary border-2 border-primary flex items-center justify-center z-10 shadow-md">
                        <Icon className="w-5 h-5 text-primary" />
                      </div>

                      {}
                      <div className={`ml-20 md:ml-0 w-full md:w-1/2 ${isEven ? "md:pr-16 md:text-right" : "md:pl-16 md:ml-auto md:text-left"}`}>
                        <div className="bg-secondary/80 border border-primary/20 p-6 md:p-8 backdrop-blur-sm hover:border-primary/50 transition-colors duration-300 shadow-lg">
                          <h3 className="font-default text-2xl md:text-3xl font-bold text-primary mb-3">
                            {step.period}
                          </h3>
                          <p className="text-secondary-foreground/90 text-lg md:text-xl font-medium">
                            {step.description}
                          </p>
                        </div>
                      </div>
                    </div>;
              })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}